// extracted by mini-css-extract-plugin
export default {"container":"Success_container__n-E6O","formSubtitle":"Success_formSubtitle__KHbKM"};